var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmiLogoMedium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 38,
    viewBox: "0 0 82 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6032 0.217285L-0.000152588 27.2391H31.2023L15.6032 0.217285Z",
    fill: "#5DB7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6034 9.23926L7.93679 22.5186H23.27L15.6034 9.23926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2351 22.3687V27.2739H21.0318V22.3687H10.2351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.1849 19.8726H10.2135V35.4416H13.1849V19.8726Z",
    fill: "#0C4480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.1682 23.8218H14.1968V37.7829H17.1682V23.8218Z",
    fill: "#0C4480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.0444 19.8687H18.0729V35.4377H21.0444V19.8687Z",
    fill: "#0C4480"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.2945 22.8913H40.0223L38.8175 26.3687H34.9713L41.5359 8.08545H45.798L52.3627 26.3687H48.4908L47.2902 22.8913H47.2945ZM46.2997 19.9627L43.6584 12.3261L41.0171 19.9627H46.2997Z",
    fill: "#0C4480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M74.7321 8.11133V26.3688H71.0703V14.4959L66.1779 26.3688H63.4037L58.4856 14.4959V26.3688H54.8238V8.11133H58.9829L64.7886 21.6865L70.5943 8.11133H74.7278H74.7321Z",
    fill: "#0C4480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M82 8.11133V26.3688H78.3382V8.11133H82Z",
    fill: "#0C4480"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmiLogoMedium);
export default __webpack_public_path__ + "static/media/AMI-logo-medium.2337b3e61599f4a3951f48058c7775f0.svg";
export { ForwardRef as ReactComponent };